import React from 'react'
import { Button } from 'react-bootstrap'
import { FooterText, Text, Wrapper } from '../../styled'
import { YouTubeWrapper } from './styled'
import { SubmitButtonStyles } from '../EnterMailbox/styled'

export const Enable2Step = ({ email, nextStep, provider }) => {
  const handleButtonClick = () => {
    nextStep()
  }

  let link = ''
  switch (provider) {
    case 'yahoo':
      link = 'https://login.yahoo.com/account/security'
      break
    case 'google':
      link = 'https://myaccount.google.com/signinoptions/two-step-verification'
      break
    default:
      link = 'https://appleid.apple.com/account/manage'
      break
  }

  return (
    <Wrapper>
      <Text style={{ width: '445px', maxWidth: '445px' }}>
        Enable 2-step verification for
        <br />
        <b>{email}</b>
      </Text>
      {provider === 'yahoo' ? (
        <div>
          <Text>
            <b>Step 1:</b> Log in, click profile picture in top right corner,
            and select "Manage your account"
          </Text>
          <Text>
            <b>Step 2:</b> Under "Security", follow the instructions to enable
            2-step verification.
          </Text>
        </div>
      ) : (
        <YouTubeWrapper
          src={
            provider === 'google'
              ? 'https://www.youtube.com/embed/RPivqAyLfHM'
              : 'https://www.youtube.com/embed/GE-LiLoDj9g'
          }
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      )}
      <Button target="_blank" href={link} style={SubmitButtonStyles}>
        Enable 2-Step Verification
      </Button>
      <FooterText onClick={handleButtonClick}>
        2-Step Verification Already Enabled
      </FooterText>
    </Wrapper>
  )
}
